module.exports = __webpack_public_path__ + "img/m-wash3prousa-menu-desktop.0b32664b.png";